import { environment } from 'App/configs/config';
import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import styled from 'styled-components';

const FooterContent = styled.div`
  background: #f0f0f0;
  color: #888;
  padding: 30px 10px;
  display: flex;
`;

const LeftFooter = styled.div`
  flex: 1;
`;
const CenterFooter = styled.div`
  text-align: center;
`;
const RightFooter = styled.div`
  flex: 1;
`;

export const Footer = withTranslation()(({ t }: WithTranslation) => (
  <FooterContent>
    <LeftFooter>
      {t('environment')}: <strong>{t(`environments.${environment.toLocaleLowerCase()}`).toLocaleLowerCase()}</strong>
    </LeftFooter>
    <CenterFooter>Wibax Logistics &copy; 2019</CenterFooter>
    <RightFooter />
  </FooterContent>
));
